import SiteColorManager from './site-color-manager'
import { PickColor } from './base-color-manager'

export default SiteColorManager
export { PickColor }
